var toastr = require('toastr/build/toastr.min');
window.toastr = toastr;
require('jquery/dist/jquery.min');

/* Used for FlashMessages in Login and meine.abl */
window.notificationOptions = {
  "closeButton": true,
  "debug": false,
  "newestOnTop": true,
  "progressBar": false,
  "positionClass": "toast-top-right",
  "preventDuplicates": false,
  "onclick": null,
  "showDuration": "300",
  "hideDuration": "1000",
  "timeOut": "5000",
  "extendedTimeOut": "1000",
  "showEasing": "swing",
  "hideEasing": "linear",
  "showMethod": "fadeIn",
  "hideMethod": "fadeOut"
};

$(function () {

  const $modalBackdrop = $('#modal-backdrop');

  $('[data-toastr-severity]').each(function () {
    var $this = $(this);
    var severity = $this.data('toastr-severity');
    var title = $this.data('toastr-title');
    var content = $this.data('toastr-content');
    if (severity == 'success') {
      toastr.success(content, title, notificationOptions);
    }
    if (severity == 'info') {
      toastr.info(content, title, notificationOptions);
    }
    if (severity == 'warning') {
      toastr.warning(content, title, notificationOptions);
    }
    if (severity == 'error') {
      toastr.error(content, title, notificationOptions);
    }
  });

  /**
   * Display login screen if requested in query string
   * This is set by the WebRedirect entryPoint when a protected action is called
   */
  if (window.location.search.indexOf("?showLogin") > -1) {
    // todo: replace irritating toaster with writing a string in loginBox
    toastr.info('Bitte melden Sie sich an, um fortzufahren.', '', notificationOptions);
    $('#toggleLogin').addClass('selected');
    $('#loginBox').show();
    $('#toggleSearch').removeClass('selected');
    $modalBackdrop.show();
  }

  /**
   * Show reset password dialog, hide login on links starting with #showResetPass (<a href="#showResetPass">clickme</a>)
   * todo: check if this is still used
   */
  $('a[href^="#showResetPass"]').click(function () {
    toastr.info('Bitte geben Sie Ihre 5-stellige Mitglied-Nummer an.', '', notificationOptions);
    $('#toggleLogin').addClass('selected');
    $('#resetPassword').addClass('in');
    $('#loginBox').show();
    $('#login-form').hide();
    $('#addressId').focus();
    $modalBackdrop.show();
  });

});

